import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

/**
 * A button that is active on mouse over, not click.
 *
 * @reactProps {string} label - the label for the button
 * @reactProps {string} value - the value to pass up to parent on mouseover
 * @reactProps {string} unitType - the unit type to pass up to parent on mouseover
 * @reactProps {function} onEvent - function vehicle for button action
 * @reactProps {fucntion} highlight - optional. function that controls the style
 * @reactProps {boolean} selected - controls conditional style
 */
export default class HoverButton extends React.Component {
  /**
   *  Pass value and unit type up to parents.
   *   If this button has a highlight prop, highlight.
   */
  onEvent = () => {
    const value = this.props.value;
    const unitType = this.props.unit;
    this.props.onEvent(value, unitType); //|| this.props.highlight(value);
    if (this.props.highlight) {
      this.props.highlight(value);
    }
  };

  /**
   *  Renders
   *  @return a button styled conditionally on props.selected.
   */
  render() {
    const { selected } = this.props;
    return (
      <button className={cx('button', { selected })} onMouseOver={this.onEvent}>
        <span>{this.props.label}</span>
      </button>
    );
  }
}

HoverButton.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  unit: PropTypes.string,
  onEvent: PropTypes.func,
  highlight: PropTypes.func,
  selected: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/HoverButton.js